// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"413":"e28e2d4a","770":"6d469381"}[chunkId] + ".chunk.css";
};